import { isBrowser } from ".";
export const turnOffDocumentBodyScroll = () => {
    try {
        if (!isBrowser()) {
            return;
        }
        const document = window.document;
        const top = window.scrollY || document.documentElement.scrollTop;
        document.documentElement.style.height = "100vh";
        document.body.style.position = "fixed";
        document.body.style.top = `-${top}px`;
    }
    catch (err) {
        console.error("Failed turning off scrolling", err);
    }
};
export const turnOnDocumentBodyScroll = () => {
    try {
        if (!isBrowser()) {
            return;
        }
        const document = window.document;
        if (!document.body.style.position)
            return;
        const scrollY = document.body.style.top;
        document.documentElement.style.height = "";
        document.body.style.position = "";
        document.body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    catch (err) {
        console.error("Failed turning on scrolling", err);
    }
};
//# sourceMappingURL=document.js.map